




























































import Vue from "vue";
import Component from "vue-class-component";
import { MeService as meApi } from "@/common/api/services/MeService";
import QErrors from "@/common/qErrors.vue";
import qNotify from "@/common/qNotify";
@Component({
  name: "Profile",
  components: {
    QErrors,
  },
})
export default class Profile extends Vue {
  member: any = {
    id: null,
    name: "",
    email: "",
  };
  errors = {};
  isShow = false;

  async getProfile() {
    const result = await meApi.meProfile({});
    if (result.data) {
      this.member = result.data.member;
    } else {
      qNotify.error({
        text: result.message || "データの取得に失敗しました",
      });
    }
  }

  async submit() {
    let result;
    try {
      result = await meApi.meUpdateProfile(this.member);
      this.member = result.data.member;
    } catch (error) {
      result = error;
    }

    if (result.status == "success") {
      qNotify.success({
        text: this.$t("common.message.updated"),
      });
      this.$emit("reload");
      this.isShow = false;
    } else if (result.status == "400") {
      this.errors = result.body.errors;
    } else {
      qNotify.error({
        text: result.body.message,
      });
    }
  }

  show() {
    this.isShow = true;
    this.getProfile();
    this.errors = {};
  }

  close() {
    this.isShow = false;
  }
}
